<bh-header type="default"></bh-header>
<div class="bh-store-hero">
    <bh-crumbs [title_show]="false" white="true"></bh-crumbs>
    <div class="bh-container">
        <h1 [innerHTML]="'Browse our Award-Winning K-8 Workbooks!' | highlightWords:['Award-Winning']: 'bh-highlight-sap'"></h1>
        <p>Discover the perfect workbooks for your child!</p>
        <p>ArgoPrep offers free shipping along with a 30 day return period.</p>
        <div class="bh-store-hero-search">
            <div class="bh-form bh-form-inline">
                <div class="bh-form-input-group flex-grow flex-shrink-0 w-full">
                    <div class="bh-form-input bh-form-input-lg" [class.bh-form-input-readonly]="interface.submit">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                        <input name="search" type="text" role="presentation" placeholder="Enter workbook name..." [readonly]="interface.submit" [value]="interface.search_query.normalise || ''" (keyup)="actionEnterSearchString($event)" (paste)="actionPasteSearchString($event)" (focusout)="actionGrantSearchString()">
                        <svg *ngIf="interface.search_query.normalise" (click)="actionClearSearchString()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 ml-auto !text-sap-500">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>
                    <div class="bh-form-text !gap-x-2">
                        <span class="!text-pap-50">Search Examples:</span>
                        <ng-container *ngFor="let search of ['1st grade','Math','SHSAT','Brain Hunter']; let ci = index">
                            <span class="bh-form-link bh-form-link-sap" (click)="actionSelectSearchString(search)">{{search}}</span>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="bh-store-hero-workbooks" [class.bh-store-hero-workbooks-line]="interface.search_query.normalise">
            <ng-container *ngFor="let workbooks_group of interface._cache.hero_workbooks; let ci = index">
                <div *ngIf="!interface.search_query.normalise" class="bh-store-hero-workbooks-group">
                    <ng-container *ngFor="let workbook of workbooks_group; let ci = index">
                        <div class="bh-store-hero-workbook" [routerLink]="'/store/product/'+workbook.slug">
                            <img ngSrc="{{workbook.thumbnail}}" alt="{{workbook.title}}"  width="172" height="212">
                            <label>
                                <button class="bh-btn bh-btn-sm bh-btn-pap">Details</button>
                            </label>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="interface.search_query.normalise" class="bh-store-hero-workbooks-group-line">
                    <ng-container *ngFor="let workbook of workbooks_group; let ci = index">
                        <div class="bh-store-hero-workbook" [routerLink]="'/store/product/'+workbook.slug">
                            <img ngSrc="{{workbook.thumbnail}}" alt="{{workbook.title}}"  width="172" height="212">
                            <label>
                                <button class="bh-btn bh-btn-sm bh-btn-pap">Details</button>
                            </label>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="workbooks_group.length == 0">
                        <div class="bh-store-no-search-workbook">
                            <p>No workbooks found for your search criteria.</p>
                            <p>Please try again with different keywords.</p>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="bh-container">
    <div class="bh-store-content">
        <bh-awards  [type]="'store'"></bh-awards>
        <bh-grades ></bh-grades>
        <bh-workbooks-series-list  ></bh-workbooks-series-list>
        <bh-workbooks-list   [count]="6" [title_text]="'Bestselling Books'" [bestselling]="true"></bh-workbooks-list>
        <bh-workbooks-list   [count]="18" [title_text]="'Featured Books'" [featured]="true"></bh-workbooks-list>
        <bh-seen  [type]="'store'"></bh-seen>
        <bh-bundles ></bh-bundles>
        <bh-testimonials  [count]="9"></bh-testimonials>
        <bh-community></bh-community>
        <bh-garantie></bh-garantie>
    </div>
</div>
<bh-footer type="public"></bh-footer>
